import { render, staticRenderFns } from "./AWSLogin.vue?vue&type=template&id=3f5b1d4a&"
import script from "./AWSLogin.vue?vue&type=script&lang=ts&"
export * from "./AWSLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports